function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './Select.css';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
const SelectField = props => {
  const {
    required = false,
    label = 'label',
    name = 'name',
    rtl,
    updateContext,
    options = [],
    patternInvalidMessage = 'validateError',
    validate = false,
    value: contextValue = '',
    isString,
    callBackAction,
    parentDependent,
    parentValueId
  } = props;
  const [inValid, setInValid] = useState(false);
  const [selected, setSelected] = useState(null);
  const onChangeEvent = _ref => {
    let {
      value
    } = _ref;
    required && setInValid(!value.length);
    updateContext({
      [name]: _objectSpread(_objectSpread({}, props), {}, {
        valid: required && !!value.length,
        value: isString ? value.toString() : parseFloat(value)
      })
    });
    callBackAction && callBackAction(value);
  };
  useEffect(() => {
    if (!options.length) return;
    updateContext({
      [name]: _objectSpread(_objectSpread({}, props), {}, {
        options
      })
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options]);
  useEffect(() => {
    if (validate) required && setInValid(!(contextValue && contextValue.length));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validate]);
  useEffect(() => {
    if (!contextValue) {
      setSelected(null);
      return;
    }
    const selectedOption = options.find(_ref2 => {
      let {
        lookupId
      } = _ref2;
      return lookupId == contextValue;
    });
    selectedOption && setSelected({
      value: isString ? selectedOption.lookupId.toString() : parseFloat(selectedOption.lookupId),
      valid: true,
      label: rtl ? selectedOption.name.ar || '' : selectedOption.name.en || ''
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contextValue]);
  useEffect(() => {
    if (!parentDependent || options.length === 0 || !contextValue) {
      return;
    }
    const currentOption = options.find(_ref3 => {
      let {
        lookupId
      } = _ref3;
      return contextValue.toString() === lookupId.toString();
    });
    const parentLookupId = currentOption && currentOption.parentLookupId || '';
    if (parentValueId && parentLookupId && parentLookupId.toString() !== parentValueId.toString()) setSelected(null);
  }, [parentDependent, parentValueId, options, contextValue]);
  return /*#__PURE__*/React.createElement("div", {
    className: `${rtl ? rtlStyles : ltrStyles} ${commonStyles}`
  }, /*#__PURE__*/React.createElement("fieldset", {
    className: `  form-select`
  }, /*#__PURE__*/React.createElement("label", {
    className: `body-small wiz__label `,
    htmlFor: name
  }, label), /*#__PURE__*/React.createElement(Select, {
    name: name,
    placeholder: '',
    isDisabled: parentDependent && !parentValueId,
    className: `dynamic-pop-up__select ${inValid ? ' invalid-field' : ''}`,
    classNamePrefix: "select-dropdown",
    onChange: onChangeEvent,
    value: selected,
    options: options.filter(_ref4 => {
      let {
        parentLookupId
      } = _ref4;
      return parentDependent && parentLookupId && parentValueId && parentLookupId.toString() === parentValueId.toString() || !parentDependent;
    }).map(_ref5 => {
      let {
        lookupId,
        name
      } = _ref5;
      const label = name && rtl ? name.ar || '' : name.en || '';
      return {
        value: lookupId,
        label: label
      };
    })
  }), inValid && /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("p", {
    className: "text-input__error"
  }, patternInvalidMessage))));
};
const commonStyles = "c1kscq9n";
const rtlStyles = "rjxfdit";
const ltrStyles = "la5os5n";
export default SelectField;